/* Dev-store addition: the theme's MediaCarousel only autoplays a video on the
   carousel:settle event (i.e. after a swipe), so a video that is the FIRST
   gallery slide never starts on page load. Kick it manually. */
(function () {
  function playInitialVideo() {
    document.querySelectorAll('media-carousel[autoplay]').forEach(function (carousel) {
      var slide = null;
      try {
        slide = carousel.selectedSlide;
      } catch (e) {
        /* custom element not upgraded yet */
      }
      slide = slide || carousel.querySelector('[data-media-type]');
      if (!slide || slide.getAttribute('data-media-type') !== 'video') return;
      var video = slide.firstElementChild;
      if (video && typeof video.play === 'function') {
        video.muted = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-carousel').then(function () {
      requestAnimationFrame(playInitialVideo);
    });
  }
  window.addEventListener('load', playInitialVideo);
})();
